<template>
    <div>
        <div class="item-wrapper d-flex align-items-center clickable" @click="startChat">
            <div
                v-if="data.avatar"
                :style="{
                    backgroundImage: 'url(\'' + data.avatar + '/small.jpg\')',
                }"
                class="avatar"
            ></div>
            <div v-else class="avatar" style="display:flex;justify-content:center;">
                <BaseIcon class="icon" name="user" size="3x" />
            </div>
            <div class="item-content d-flex flex-column justify-content-center">
                <div>{{ data.displayName }}</div>
                <div v-if="data.title">
                    <strong>{{ data.title }}</strong>
                </div>
            </div>
        </div>
        <hr class="divider" />
    </div>
</template>

<script>
export default {
    name: 'NewChatListItem',
    props: {
        data: Object,
    },
    methods: {
        startChat() {
            this.$root.$emit('chat-conversation-create-update', this.data.id);
        },
    },
};
</script>

<style scoped>
.item-wrapper {
    padding: 15px;
}
.item-content {
    margin-left: 10px;
}
.divider {
    margin: 0;
    width: 100%;
    border-top: 1px solid #f3f3f3;
}
.avatar {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
}
</style>
